import React, { useState } from 'react';
import { formatCurrency } from '../../../lib/formatters/currency';
import DataModeBadge from '../../../components/feedback/DataModeBadge';
import { openBillingPortal } from '../../../lib/api/clients';

const PLAN = {
  name: 'Agency Scale',
  price: 2400,
  cycle: 'month',
  renewsOn: '2026-10-01',
  seats: { used: 3, total: 10 }
};

/**
 * Billing tab (full-live-cutover §3, Settings build). The plan summary is
 * the labeled sample (no subscription read exists); the portal button calls
 * the REAL backend route /api/clients/me/billing-portal — which answers an
 * honest 501 while Stripe is out of scope — and renders "not yet live"
 * instead of failing silently (the billing-portal 404 lesson, closed).
 */
function BillingTab() {
  const [portalState, setPortalState] = useState('idle'); // idle | opening | notlive

  const handleOpenPortal = async () => {
    setPortalState('opening');
    try {
      await openBillingPortal();
      setPortalState('idle');
    } catch (portalError) {
      // apiFetch throws "API request failed: 501" — the honest refusal.
      setPortalState('notlive');
    }
  };

  return (
    <div className="settings-tab">
      <section className="settings-billing-summary">
        <div>
          <h2>
            {PLAN.name}{' '}
            <DataModeBadge mode="sample" label="Sample plan — no subscription read yet" />
          </h2>
          <p>
            {formatCurrency(PLAN.price)} / {PLAN.cycle} · renews {PLAN.renewsOn}
          </p>
        </div>
        <div className="settings-billing-seats">
          <span>Seats</span>
          <strong>{PLAN.seats.used} / {PLAN.seats.total}</strong>
        </div>
      </section>

      <div className="settings-form-foot">
        <button
          className="portal-primary-button"
          disabled={portalState === 'opening'}
          onClick={handleOpenPortal}
          type="button"
        >
          {portalState === 'opening' ? 'Opening…' : 'Open billing portal'}
        </button>
        {portalState === 'notlive' && (
          <span className="portal-error" role="alert">
            The billing portal is not live yet — Stripe session creation ships
            with the billing task. No charge or plan change was made.
          </span>
        )}
      </div>

      <p className="settings-note">
        The agency's own Stripe subscription is managed in the Stripe dashboard.
        Invoice history will appear here once the billing API is wired
        (BUILD.md §9).
      </p>
    </div>
  );
}

export default BillingTab;
